import React from 'react';
import styles from './MoneyBack.module.css'; // Adjust the path as necessary
import { useTranslation } from 'react-i18next'; // Import the useTranslation hook
import BubbleButton from '../../UI/Buttons/BubbleButton/BubbleButton';

const MoneyBack = () => {
    const { t } = useTranslation(); // Initialize the translation function

    const plansData = [
        {
            title: t('plans.1_month_plan.title'),
            description: t('plans.1_month_plan.description'),
            price: t('plans.1_month_plan.price'),
            discount: t('plans.1_month_plan.discount'),
            buttonText: t('plans.1_month_plan.button_text')
        },
        {
            title: t('plans.3_month_plan.title'),
            description: t('plans.3_month_plan.description'),
            price: t('plans.3_month_plan.price'),
            discount: t('plans.3_month_plan.discount'),
            buttonText: t('plans.3_month_plan.button_text')
        },
        {
            title: t('plans.6_month_plan.title'),
            description: t('plans.6_month_plan.description'),
            price: t('plans.6_month_plan.price'),
            discount: t('plans.6_month_plan.discount'),
            buttonText: t('plans.6_month_plan.button_text')
        }
    ];

    return (
        <div className={`${styles.plansContainer} ${styles.fcvRow}`} style={{
            position: "relative",
            overflow: "hidden"
        }}>
            <div className={styles.content}>
                <i></i>
                <i></i>
                <i></i>
            </div>
            <p className={styles.moneyBackTitle}>{t('moneyBack.title')}</p>
            <div className={styles.descContainer}>

                <p className={styles.moneyBackDesc}>
                    {t('moneyBack.desc')}

                    <p className={styles.supportTeam}>
                        {' '}                {t('moneyBack.supportTeam')}
                    </p>
                </p>
            </div>
            {/* <div className={styles.verifyButton} style={{margin:"auto"}}>
                <BubbleButton to="" dark headerDarkButton>{t('moneyBack.buttonText')}</BubbleButton>
            </div> */}
        </div>
    );
};

export default MoneyBack;
